module.exports = __webpack_public_path__ + "img/benefits-19.7cfc2b7e.svg";